import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import {
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
  subModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { AdministratorFacade, getRolesAndPermission } from '@piqet-angular/data';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';

@Injectable({
  providedIn: 'root',
})
export class OtherCircularEconomyParameterDataGridService {
  circularEconomyParameterDataPayload: any;
  event: any;

  editCircularData = new Subject<[any, any, any]>();
  circularObservable$ = this.editCircularData.asObservable();

  deleteCircularData = new Subject<[any, any, any]>();
  circularDeleteObservable$ = this.deleteCircularData.asObservable();

  constructor(private AdministratorFacade: AdministratorFacade, private swalService: SwalService) {}

  getCircularEconomyParameterDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'MaterialCategoryName',
      headerName: 'Material category',
      field: 'materialCategoryName',
      minWidth: grid_widths_map.lg_column_sm,
      cellClass: 'my-permission-cursor-pointer',
      // sort: 'asc',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      editable: false,
      cellRenderer: (params: any, pathName: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.innerHTML = `${cellValue}`;
        cellElement.style.cursor = 'pointer';
        cellElement.style.textDecoration = 'underline';
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          if (
            params.columnApi.columnModel.columnDefs[
              params.columnApi.columnModel.columnDefs.length - 1
            ].cellRendererParams?.showEdit
          )
            this.editCircularData.next([
              params.data?.materialId,
              'Review circular economy parameter detail',
              location.href.split('/')[7],
            ]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialCode',
      headerName: 'Material code',
      field: 'materialCode',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialName',
      headerName: 'Material',
      field: 'materialName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      cellRendererParams: {
        showCopy: false,
        showEdit: this.isAccess() ? this.isAccess().isEdit : true,
        showDelete: this.isAccess() ? this.isAccess().isDelete : true,
        deleteData: (data: any, pathName: any) => {
          this.deleteCircularDataConfirmation(
            data.circularEconomyParameterId,
            '/CircularEconomyParameters/DeleteCircularEconomyParameters?circularEconomyParameterId',
            pathName
          );
        },
        editData: (data: any, pathName: any) => {
          this.editCircularData.next([
            data.materialId,
            'Review circular economy parameter detail',
            pathName,
          ]);
        },
      },
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  isAccess = () => {
    return getRolesAndPermission(
      rolesModuleName.DataManageOtherDataCircularEconomy,
      subModuleName.otherDataModule
    );
  };

  deleteCircularDataConfirmation(data: any, customType: any, pathName: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteCircularData.next([data, customType, pathName]);
      }
    });
  }

  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getCircularEconomyParameterDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.circularEconomyParameterDataPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'MaterialCategoryName',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Desc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }
}
